/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgCompositeForm = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M22 22H6V6h16zm-10-2h8v-3h-8zm-4 0h2v-3H8zm4-5h8v-3h-8zm-4 0h2v-3H8zm0-5h12V8H8zM5 20H2V2h18v3h-2V4H4v14h1z"
      fill="currentcolor"
    />
  </Icon>
);
export { SvgCompositeForm as CompositeForm };
